/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Free_Feat2Inputs */

const en_mk_price_free_feat2 = /** @type {(inputs: Mk_Price_Free_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200 issues, unlimited channels & DMs`)
};

const id_mk_price_free_feat2 = /** @type {(inputs: Mk_Price_Free_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200 issue, channel & DM tanpa batas`)
};

/**
* | output |
* | --- |
* | "200 issues, unlimited channels & DMs" |
*
* @param {Mk_Price_Free_Feat2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_free_feat2 = /** @type {((inputs?: Mk_Price_Free_Feat2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Free_Feat2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_free_feat2(inputs)
	return en_mk_price_free_feat2(inputs)
});